import React, { useState } from 'react'
import {
  Box,
  Button,
  Heading,
  Typography,
  Frame,
  TagsForm
} from 'components'
import { useContent } from 'utils'
import { ProgressBarFooter } from './FreelancerProgressBarFooter'
import firebase from 'utils/firebase'
import { ONBOARD_SKIP_VALIDATION } from '../../../constants'

const FreelancerSkillTags = ({
  onboarding,
  user,
  role = "freelancer",
  tags,
  stepIndex,
  totalSteps,
  onNext = () => { },
  onSubmit = () => { }
}) => {
  const { contactEmail, landing } = useContent() || {}
  const buttonColor = landing?.['onboarding-button-color'] || 'primary'
  // Initialize with user's existing skills if available
  const [skills, setSkills] = useState(user?.skills || [])

  const handleChange = (data) => {
    // Extract skills array from the object passed by TagsForm
    // TagsForm passes { skills: [...] } as seen in TagsForm.js line 66
    const selectedSkills = data.skills || []

    setSkills(selectedSkills)
    // console.log('Updated skills length:', selectedSkills.length)
  }

  const handleSubmit = () => {
    if (ONBOARD_SKIP_VALIDATION || skills.length > 0) {
      // Save skills to user profile
      if (onboarding) {
        firebase.analytics().logEvent('user_freelancer_skills_submit_click')
      }

      // console.log('Updating user with skills data:', skills);

      // Use direct Firebase update with set and merge to ensure data is saved properly
      firebase
        .firestore()
        .collection('users')
        .doc(user.id)
        .set({
          skills: skills
        }, { merge: true })
        .then(() => {
          // console.log('Skills successfully saved to database');

          if (onSubmit) {
            onSubmit({ skills })
          }

          if (onNext) {
            onNext()
          }
        })
        .catch(error => {
          console.error('Error updating skills:', error)
        });
    }
  }

  return (
    <Frame maxWidth="xs" user={user}>
      <Box mx="auto" maxWidth={430}>
        <Heading>
          Share your skills and experiences with these tags. You can choose up to 15.
        </Heading>

        <Typography>
          Are we missing a skill? Email us at {contactEmail}
        </Typography>

        <Box my={3}>
          <TagsForm
            tags={tags}
            value={skills}
            role={role}
            onChange={handleChange}
            maxTags={15}
          />
        </Box>

        {/* Add standalone Next button when not in onboarding mode */}
        {!onboarding && (
          <Box mx="auto" my={3} maxWidth={280}>
            <Button
              variant="contained"
              type="submit"
              style={{ width: '100%', 'background-color': buttonColor }}
              onClick={handleSubmit}
              disabled={!ONBOARD_SKIP_VALIDATION && skills.length === 0}
            >
              Next
            </Button>
          </Box>
        )}
      </Box>

      {onboarding && (
        <ProgressBarFooter
          valid={skills.length > 0}
          stepIndex={stepIndex}
          firstStep={stepIndex}
          numSteps={totalSteps}
          onNext={handleSubmit}
          onPrev={() => { }}
          alwaysShowNav={ONBOARD_SKIP_VALIDATION}
        />
      )}
    </Frame>
  )
}

export default FreelancerSkillTags
